import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import {message, Row, Col, Skeleton, Checkbox, Spin, Form, Table, Popconfirm} from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import AirButton from "../../../../../common/components/AirButton";
import AirInput from "../../../../../common/components/AirInput";
import {ArrowLeftIcon, DeleteIcon, EditIcon} from '../../../../../common/icons';
import { api } from '../../../../../services';
import ManageVehiclesModal from './ManageVehiclesModal';
import ManageScheduleModal from './ManageScheduleModal';
import Map from '../../../../../common/components/Map';
import "./GeofenceForm.css";

@withRouter
@inject("translationsStore", "geofencesStore", "mapStore")
@observer
class GeofenceForm extends Component {
    constructor(props) {
        super(props);

        this.MapRef = React.createRef();

        const { translationsStore, geofence } = props;
        let statusOptions = [{ label: this.props.translationsStore.translate("geofence.status.ENABLED"), value: "ENABLED" }];
        this.schedulesColumns = [
            {
                dataIndex: 'type',
                title: translationsStore.translate('geofence.schedules.column.type'),
                render: (text, record) => <span>{translationsStore.translate('geofence.type.' + record.type)}</span>
            },
            {
                dataIndex: 'days',
                title: translationsStore.translate('geofence.schedules.column.days'),
                render: (text, record) => <span>{record.days.sort().map(x => translationsStore.translate('geofence.days.' + x)).join(' ')}</span>
            },
            {
                dataIndex: '',
                title: translationsStore.translate('geofence.schedules.column.timeOfDay'),
                render: (text, record) => <span>{record.timeStart ? moment(record.timeStart).format('HH:mm') : '-'} - {record.timeEnd ? moment(record.timeEnd).format('HH:mm') : '-'}</span>
            },
            {
                dataIndex: 'status',
                title: translationsStore.translate('geofence.schedules.column.status'),
                render: text => <span>{translationsStore.translate('geofence.status.' + text)}</span>
            },
            {
                dataIndex: '',
                title: '',
                width: '100px',
                render: (text, record) => (
                  <div className={'ActionColumn'}>
                      <EditIcon onClick={() => this.editSchedule(record)}/>
                      {record.type !== null && record.type !== '' && record.days && record.days.length > 0 && (
                        <Popconfirm
                          title={translationsStore.translate('geofence.detail.deleteConfirm')}
                          onConfirm={() => this.deleteSchedule(record)}
                          okText={translationsStore.translate('geofence.detail.deleteConfirmYes')}
                          cancelText={translationsStore.translate('geofence.detail.deleteConfirmNo')}
                        >
                            <DeleteIcon/>
                        </Popconfirm>
                      )}
                  </div>
                )
            }
        ];
        this.state = {
            loading: false,
            geofence: (!geofence) ? { status: ["DISABLED"], schedules: [], vehicles: [], type: '', options: {} } : geofence,
            schedule: {
                type: null,
                status: [],
                days: [],
                timeStart: moment("06:00", "HH:mm A"),
                timeEnd: moment("23:00", "HH:mm A")
            },
            statusOptions: statusOptions
        };
        this.ManageVehiclesModalRef = React.createRef();
        this.ManageScheduleModalRef = React.createRef();
    }

    static contextTypes = {
        router: PropTypes.object
      };

    componentDidMount() {
        this.MapInstace = this.MapRef.current.wrappedInstance;
        this.ManageVehiclesModalInstance = this.ManageVehiclesModalRef.current.wrappedInstance;
        this.ManageScheduleModalInstance = this.ManageScheduleModalRef.current.wrappedInstance;
        if (this.props.geofence) {
            this.setGeofenceData(this.props.geofence);
        }
        // INFO with recent changes, produces choppy behavior
        // this.MapInstace.whenMapIsReady()
        // .then(() => {
        //     let lat = 41.89193;
        //     let lng = 12.51133;
        //     if (this.props.geofence && this.props.geofence.options) {
        //         if (this.props.geofence.options.lat)
        //             lat = this.props.geofence.options.lat;
        //         if (this.props.geofence.options.lng)
        //             lng = this.props.geofence.options.lng;
        //     }
        //     this.MapInstace.setCenter(lat, lng);
        //     if (this.props.geofence && this.props.geofence.options && this.props.geofence.options.radius) {
        //         this.MapInstace.adaptZoom(Math.max(200, this.props.geofence.options.radius));
        //     } else {
        //         this.MapInstace.setZoom(5);
        //     }
        // })
        // .catch(e => console.warn(e));
    }

    componentDidUpdate (prevProps) {
        if (this.props.geofence !== prevProps.geofence) {
            this.setGeofenceData(this.props.geofence);
            this.MapInstace.whenMapIsReady()
            .then(() => {
                const usingApiKey = this.props.mapStore.usingApiKey;
                let lat = 41.89193;
                let lng = 12.51133;
                if (this.props.geofence && this.props.geofence.options) {
                    if (this.props.geofence.options.lat)
                        lat = this.props.geofence.options.lat;
                    if (this.props.geofence.options.lng)
                        lng = this.props.geofence.options.lng;
                }
                this.MapInstace.setCenter(lat, lng);
                if (this.props.geofence && this.props.geofence.options && this.props.geofence.options.radius) {
                    this.MapInstace.adaptZoom(Math.max(200, this.props.geofence.options.radius));
                } else if (this.props.geofence && this.props.geofence.options && this.props.geofence.options.mapView && this.props.geofence.options.mapView.radius) {
                    this.MapInstace.adaptZoom(Math.max(200, this.props.geofence.options.mapView.radius));
                } else {
                    this.MapInstace.setZoom(5);
                }

                if (this.props.geofence && this.props.geofence.options) {
                    this.MapInstace.initGeofenceArea(this.state.geofence.type, this.props.geofence.options);
                }
            });
        }
    }

    setGeofenceData(geofence) {
        if (!geofence) {
            geofence = { status: ["DISABLED"], schedules: [], vehicles: [], type: '', options: {} };
        } else {
            if (geofence.schedules && geofence.schedules.length > 0) {
                geofence.schedules.forEach(schedule => {
                    schedule.key = schedule.id;
                    schedule.days = schedule.days.map(String);
                    schedule.timeStart = moment(schedule.timeStart, "HH:mm");
                    schedule.timeEnd = moment(schedule.timeEnd, "HH:mm");
                    let status = [];
                    status.push(schedule.status);
                    schedule.status = status;
                });
            } else {
                geofence.schedules = [];
            }
            if (!geofence.vehicles) {
                geofence.vehicles = [];
            }
            if (geofence.status) {
                let status = [];
                status.push(geofence.status);
                geofence.status = status;
            }
        }
        this.setState({
          geofence: geofence,
          loading: false
        });
    }

    backToList() {
        this.props.history.goBack();
    }

    save() {
        let geofence = this.state.geofence;
        let isError = false;
        if (geofence.name === null || geofence.name === "") {
            isError = true;
        }
        if (!geofence.schedules || geofence.schedules.length === 0) {
            isError = true;
        }
        if (isError) {
            message.error(this.props.translationsStore.translate('geofence.detail.requiredFieldsMissing'));
        } else {
            for (const schedule of geofence.schedules) {
              schedule.timeEnd = schedule.timeEnd.format("YYYY-MM-DDTHH:mm:ss");
              schedule.timeStart = schedule.timeStart.format("YYYY-MM-DDTHH:mm:ss");
            }

            if (geofence.vehicles && geofence.vehicles.length > 0) {

                geofence.vehicles = geofence.vehicles.map(x => (x.carId ? x.carId : x)).map(String);
            } else {
                geofence.vehicles = [];
            }
            api('updateGeofence', this.props.geofenceId, geofence).then(result => {
                if (result.success === true) {
                    message.success(this.props.translationsStore.translate('geofence.detail.saved'));
                    this.context.router.history.push(`/geofence-manager`);
                }
            }).catch(err => {
                message.error(this.props.translationsStore.translate('geofence.detail.saveError'));
            });
        }
    }

    setName = e => {
        let geofence = this.state.geofence;
        geofence.name = e.target.value;
        this.setState({
            geofence: geofence
        });
    };

    onChangeStatus = checkedList => {
        let geofence = this.state.geofence;
        geofence.status = checkedList.length > 0 ? checkedList : ['DISABLED'];
        this.setState({
            geofence: geofence
        });
    }

    onChangeVehicles = vehicles => {
        let geofence = this.state.geofence;
        geofence.vehicles = vehicles;
        this.setState({
            geofence: geofence
        });
    }

    onChangeSchedules = schedule => {
        let geofence = this.state.geofence;
        if (geofence.schedules.length === 0) {
            geofence.schedules.push(schedule);
        } else {
            let schedules = geofence.schedules.filter(function(e) {
                if (e.key !== schedule.key) {
                    return true;
                } else {
                    return false;
                }
            });
            schedules.push(schedule);
            geofence.schedules = schedules;
        }
        this.setState({
            geofence: geofence
        })
    }

    openScheduleModal = key => {
        let defaultSchedule = {
            key: new Date().getUTCMilliseconds(),
            type: "",
            status: ["DISABLED"],
            days: [],
            timeStart: moment("06:00", "HH:mm"),
            timeEnd: moment("23:00", "HH:mm"),
            isDeletable: false
        };
        let schedule = defaultSchedule;
        this.ManageScheduleModalInstance.show(schedule);
    }

    editSchedule = schedule => {
        this.ManageScheduleModalInstance.show(schedule);
    }

    deleteSchedule = schedule => {
        let geofence = this.state.geofence;
        let schedules = geofence.schedules.filter(item => {
            if (item.key !== schedule.key) {
                return true;
            } else {
                return false;
            }
        });
        geofence.schedules = schedules;
	    this.setState({ geofence: geofence });
        message.success(this.props.translationsStore.translate('geofence.detail.deleted'));
    }

    editVehicles = () => {
        this.ManageVehiclesModalInstance.show(this.state.geofence.vehicles);
    }

    onGeofenceDrawing = (type, options) => {
        let geofence = this.state.geofence;
        geofence.type = type;
        geofence.options = options;
        this.setState({ geofence: geofence });
    }

    render() {
        const { translationsStore } = this.props;
        let numberOfVehicles = 0;
        if (this.state.geofence.vehicles !== null && this.state.geofence.vehicles !== undefined) {
            numberOfVehicles = this.state.geofence.vehicles.length
        }
        const labelAssignedVehicles = numberOfVehicles > 0 ? `${numberOfVehicles} ${translationsStore.translate('geofence.detail.labelAssignedVehicles')}` : `${translationsStore.translate('geofence.detail.labelNoAssignedVehicles')}`;

        return (
            <div className="GeofenceFormContainer">
                <div className="GeofenceForm">
                    <Spin spinning={this.state.loading}>
                        <div className="buttons header">
                            <AirButton className="backButton" size="large" style={{marginLeft: '0px'}} label={translationsStore.translate("geofence.detail.back")} icon={<ArrowLeftIcon />} onClick={() => {
                                this.backToList();
                            }}/>
                            <AirButton size="large" light="true" label={translationsStore.translate("geofence.detail.save")} className="saveButton"
                            onClick={() => {this.save(); }}/>
                        </div>
                        <Skeleton loading={this.state.loading}>
                            <Row className="body" style={{ display: 'flex', width: '100%' }}>
                                <Col span={24}>
                                    <div className="title">{translationsStore.translate('geofence.detail.labelName')} *</div>
                                    <AirInput onChange={this.setName} value={this.state.geofence.name} />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <div className="title">{translationsStore.translate('geofence.detail.labelStatus')}</div>
                                    <div className="checkbox status">
                                        <Checkbox.Group options={this.state.statusOptions} onChange={this.onChangeStatus} value={this.state.geofence.status}/>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <div className="title">{translationsStore.translate('geofence.detail.labelSchedule')} *</div>
                                </Col>
                                <Col span={12}>
                                    <AirButton size="large" className="slim" light="true" label={translationsStore.translate('geofence.detail.labelAddSchedules')} onClick={() => {
                                        this.openScheduleModal(0);
                                    }}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Table
                                        id="GeofenceSchedules"
                                        dataSource={this.state.geofence.schedules || []}
                                        columns={this.schedulesColumns}
                                        rowClassName="geofenceSchedulesRow"
                                        locale={{ emptyText: translationsStore.translate('geofence.detail.NoSchedulesAvailable') }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <div className="title">{translationsStore.translate('geofence.detail.labelVehicles')}</div>
                                    <Col span={12}>
                                        <AirButton bgcolor="transparent" size="large" label={labelAssignedVehicles} style={{color: 'var(--dark-grey)', backgroundColor: 'var(--light-grey-3)', borderRadius: '25px', border: '1px solid var(--grey)', width: '248px'}} />
                                    </Col>
                                    <Col span={12}>
                                        <AirButton size="large" light="true" label={translationsStore.translate('geofence.detail.labelManageVehicles')} onClick={() => {
                                            this.editVehicles();
                                        }}/>
                                    </Col>
                                </Col>
                            </Row>
                        </Skeleton>
                        <ManageScheduleModal ref={this.ManageScheduleModalRef} geofenceId={this.state.geofence.id} schedule={this.state.schedule} width={676} onUpdate={this.onChangeSchedules}/>
                        <ManageVehiclesModal ref={this.ManageVehiclesModalRef} geofenceId={this.state.geofence.id} width={676} onUpdate={this.onChangeVehicles} />
                    </Spin>
                </div>
                <Map
                    className="GeofenceDetailMap"
                    markerId="plate"
                    style={{
                    height: 'calc(100vh - var(--header-height))',
                    width: '50%'
                    }}
                    loading={this.props.loading}
                    ref={this.MapRef}
                    geofenceType={this.state.geofence ? this.state.geofence.type : undefined }
                    geofenceOptions={this.state.geofence ? this.state.geofence.options : undefined }
                    withGeofence={true}
                    onGeofenceDrawing={this.onGeofenceDrawing}
                />
            </div>
        );
    }
}
export default Form.create()(GeofenceForm);



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceForm/GeofenceForm.js